import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { InputModule } from '../input/input.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [TextareaComponent],
  imports: [CommonModule, InputModule, TooltipModule],
  exports: [TextareaComponent],
})
export class TextareaModule {}
